import { AdminMenuItem } from "./AdminMenuItem";
import { ajax, csrfToken, fetchGetParameterValue } from "./communication/AjaxHelper";
import { GetUserDataResponse, UserData, ClassData, type Application } from "./Data";
import { TeachersWithClassesMI } from "./TeachersWithClasses";
import { ClassesWithStudentsMI } from "./ClassesWithStudentsMI";
import { StudentBulkImportMI } from "./StudentBulkImortMI";
import { Pruefungen } from "./Pruefungen";
import { w2utils } from 'w2ui';
import { AutoLogout } from "./AutoLogout";
import jQuery from 'jquery'

import 'w2ui/w2ui-2.0.css';

import "/assets/css/icons.css";
import "/assets/css/administration.css";
import "/assets/fonts/fonts.css";

import w2uiLocale from '/assets/w2uilocale/de-de.json?url'
import { extractLanguageFromGetRequest, extractSingleUseSessionTokenFromGetRequestAndRetrieveNewCsrfToken } from "./communication/AjaxHelper";
import type { SettingsStore } from "./settings/SettingsStore";
import type { SettingValues } from "./settings/SettingsMetadata";
import { SecureJSON } from "./tools/SecureJSON";
import { Settings } from "./settings/Settings";
import { InactiveStudentsMI } from "./InactiveStudentsMI";



export class Administration {

    activeMenuItem: AdminMenuItem = null;

    menuItems: AdminMenuItem[] = [
    ]

    userData: UserData;
    classes: ClassData[];
    schoolName: string;
    vidisSchoolId: string | null;
    schoolSettings: SettingValues;

    settings: SettingsStore;
    application: Application;

    async start() {
        //@ts-ignore
        w2utils.locale(w2uiLocale);

        extractLanguageFromGetRequest();
        await extractSingleUseSessionTokenFromGetRequestAndRetrieveNewCsrfToken();

        ajax("getUserData", {}, (response: GetUserDataResponse) => {
            this.userData = response.user;
            this.schoolSettings = SecureJSON.parse(response.schoolSettings);
            this.classes = response.classdata;
            this.schoolName = response.schoolName;
            this.vidisSchoolId = response.vidisSchoolId;
            this.settings = new Settings(response.user, response.user.settings, undefined, response.schoolSettings);
            this.application = response.application;

            this.initMenu();
            new AutoLogout();
            jQuery('#schoolName').text(response.schoolName);
            jQuery('#inner-heading').text((this.application == 1 ? "Online-IDE" : "SQL-IDE") + ": Backend für Lehrkräfte");


        }, (message) => {
            alert(message);
        });

    }

    initMenu() {

        this.menuItems.push(new TeachersWithClassesMI(this));
        this.menuItems.push(new ClassesWithStudentsMI(this));
        this.menuItems.push(new InactiveStudentsMI(this));

        if (this.settings.getValue("schooladmin.functionality.pruefungen") == "enabled") {
            this.menuItems.push(new Pruefungen(this));
        }

        if (!this.isVidisSchool()) {
            this.menuItems.push(new StudentBulkImportMI(this));
        }

        for (let mi of this.menuItems) {
            if (mi.checkPermission(this.userData)) {
                mi.$button = jQuery('<div class="jo_menuitem">' + mi.getButtonIdentifier() + '</div>');
                jQuery('#menuitems').append(mi.$button);
                mi.$button.on('click', () => {

                    jQuery('#main-heading').empty();

                    if (this.activeMenuItem != null) this.activeMenuItem.destroy();
                    this.activeMenuItem = mi;

                    jQuery('#main-table-left').empty().css("flex-grow", "1");
                    jQuery('#main-table-right').empty().css("flex-grow", "1");
                    this.removeGrid(jQuery('#main-table-left'));
                    this.removeGrid(jQuery('#main-table-right'));
                    jQuery('#main-footer').empty();

                    mi.onMenuButtonPressed(
                        jQuery('#main-heading'), jQuery('#main-table-left'), jQuery('#main-table-right'),
                        jQuery('#main-footer'));

                    jQuery('#menuitems .jo_menuitem').removeClass('jo_active');
                    mi.$button.addClass('jo_active');
                });
            }
        }

        let menuItemToSelect = fetchGetParameterValue('menuItem');
        if (menuItemToSelect == null) {
            jQuery('#menuitems .jo_menuitem').first().trigger("click");
        } else {
            let itemToStart = this.menuItems.find(mi => mi.identifier === menuItemToSelect);
            if (itemToStart != null) {
                itemToStart.$button.trigger("click");
            } else {
                jQuery('#menuitems .jo_menuitem').first().trigger("click");
            }
        }
    }

    removeGrid($element: JQuery<HTMLElement>) {
        $element.removeClass('w2ui-reset w2ui-grid w2ui-ss');
        $element.css('flex', '');
    }

    isVidisSchool(): boolean {
        return this.vidisSchoolId != null && this.vidisSchoolId.length > 0;
    }

}

jQuery(() => {
    new Administration().start();
});